import styled from "styled-components";
import colors from "../../../../../config/colors";
import { Scrollable } from "../../../../../common/styles";

export const EditProgramManagersContainer = styled.div`
  width: 60vw;
  @media (max-width: 767px) {
    width: 100%;
    ${Scrollable}
    max-height: 280px;
  }
`;

export const ProgramManagerLine = styled.div`
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid ${colors.secondary};
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;
export const ProgramManagerInfo = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const ManagerNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const ManagerName = styled.div`
  margin-left: 10px;
  text-transform: capitalize;
`;
export const AddMore = styled.button`
  color: #302f2f;
  font-family: "Nunito Sans";
  background: transparent;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  width: fit-content;
  border: 1px solid transparent;
  cursor: pointer;
  margin-top: 12px;
  span {
    color: #44449b;
  }
`;
export const ManagerImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
`;
